import React from 'react';
import { heroContent } from '../../data/mock';
import { Button } from '../ui/button';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-24">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroContent.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/65 to-charcoal/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-3xl mx-auto">
          {/* Tagline */}
          <p className="font-montserrat text-sm uppercase tracking-[0.3em] text-white/90 mb-6 drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] animate-fade-in">
            Egyedi dekoráció, felejthetetlen pillanatok
          </p>

          {/* Main Title */}
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 animate-fade-in-up">
            {heroContent.title}
            <span className="block text-white/95 mt-2 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">{heroContent.brandName}</span>
          </h1>

          {/* Description */}
          <p className="font-montserrat text-lg md:text-xl text-white/95 leading-relaxed mb-10 max-w-2xl mx-auto animate-fade-in-up animation-delay-200 drop-shadow-[0_4px_18px_rgba(0,0,0,0.9)]">
            {heroContent.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up animation-delay-400">
            <Button
              onClick={(e) => handleScroll(e, '#kapcsolat')}
              className="bg-warm-sage hover:bg-warm-sage/90 text-white font-montserrat text-sm uppercase tracking-wider px-8 py-6 min-w-[200px] transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              {heroContent.primaryCta}
            </Button>
            <Button
              variant="outline"
              onClick={(e) => handleScroll(e, '#galeria')}
              className="border-2 border-white text-white hover:bg-white hover:text-charcoal font-montserrat text-sm uppercase tracking-wider px-8 py-6 min-w-[200px] transition-all duration-300 bg-transparent"
            >
              {heroContent.secondaryCta}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <a
          href="#miert-mi"
          onClick={(e) => handleScroll(e, '#miert-mi')}
          className="text-white/70 hover:text-white transition-colors"
          aria-label="Görgess lejjebb"
        >
          <ChevronDown className="w-8 h-8" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
